import { baseUrl } from "../shared/api";

export function unreadNotifications(userId) {
  return `${baseUrl()}/api/v2/users/${userId}/fca_notifications/action_center_unread_notifications`;
}

export function actionCenterClick(userId, id) {
  return `${baseUrl()}/api/v2/users/${userId}/fca_notifications/${id}/action_center_click`;
}

// type == active_center_show / update_center_show
export function notifications(userId, type) {
  return `${baseUrl()}/api/v2/users/${userId}/fca_notifications?${type}=true`;
}



// WEBPACK FOOTER //
// ./src/features/notifications/apiUrls.js